import React from 'react';
import styled from 'styled-components';
import EllipseControl from '../../../../../EllipsesControl/EllipsesControl';

function RelateEntitiesItem({item}) {
	return (
		<StyledRelateEntitiesItem className="StyledRelateEntitiesItem">
			<EllipseControl content={item.name} tooltip={item.name} noOfLines={1} />
		</StyledRelateEntitiesItem>
	);
}

const StyledRelateEntitiesItem = styled.section`
	width: 100%;
`;

export default RelateEntitiesItem;
